import {combineReducers} from '@reduxjs/toolkit';

import {mcpEntitlementsStateSlice} from './slices/mcp-entitlements-state.slice';
import {mcpEntitlementsSlice} from './slices/mcp-entitlements.slice';

export const mcpEntitlementsAssignedReducer = combineReducers({
    entitlements: mcpEntitlementsSlice.reducer,
    state: mcpEntitlementsStateSlice.reducer,
});
